import React from 'react';
import { IconProps } from '.';

const SvgSync = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M21.017 9A9.504 9.504 0 0 0 3.5 7.75H5.5v1.5H.75V4.5h1.5v2.402A10.999 10.999 0 0 1 12 1c5.035 0 9.28 3.383 10.586 8h-1.57ZM2.983 15A9.504 9.504 0 0 0 20.5 16.25H18.5v-1.5h4.75v4.75h-1.5v-2.402A10.999 10.999 0 0 1 12 23c-5.035 0-9.28-3.383-10.586-8h1.57ZM1 11.988v.024-.024Z'
      />
    </svg>
  );
};

export default SvgSync;
